<template lang="pug">

	b-list-group-item.sessionCard(:variant="getVariant(_sessionItem)")
		.sessionCard__header
			h5.sessionCard__title {{ _sessionItem.title }}

			div(v-for="person in _sessionItem.speaker" :key="person.id")
				i {{person.first_name}} {{person.last_name}}
					span(v-if="person.company || person.organisation")
						| , {{ person.company || person.organisation }}

			small.sessionCard__time(v-if="_sessionItem.start_timestamp && _sessionItem.end_timestamp")
				| {{ _sessionItem.start_timestamp|dateFormat('d mmmm') }}
				| {{ _sessionItem.start_timestamp|dateFormat(dateRegExp) }}
				| -
				| {{ _sessionItem.end_timestamp|dateFormat(dateRegExp) }}
			small.sessionCard__time(v-else)
				| дата и время не заданы

		.sessionCard__cats.badge-list
			b-badge.badge-list__badge(v-for="cat in _sessionItem.category" :variant="cat.color || 'primary'" :key="cat.id" ) {{ cat.title }}

		.sessionCard__text(v-html="_sessionItem.description") {{ _sessionItem.description }}
		.sessionCard__footer(v-if="_participantID && isSelectionStage")
			a(@click="_toggle($event, _sessionItem.id, isActive(_sessionItem))" href="#!")
				i.mr-1(:class="isActive(_sessionItem)?'icon-user-unfollow':'icon-user-follow'")
				| {{ isActive(_sessionItem) ? 'Убрать из программы' : 'Добавить в программу'}}

</template>

<script>
	import { mapState } from 'vuex';


	export default {
		name: 'sessionsListItem',
		props: ['_sessionItem', '_participantID','_toggle'],
		data: () => ({
			dateRegExp: "HH:MM",
		}),
		computed: {
			...mapState(['myParticipant']),
			activeSessions() { return this.myParticipant.data.session || [] },
			isSelectionStage(){
				return !this.myParticipant.data.id
					? false
					: this.myParticipant.data.stage.order>=this.myParticipant.data.event.selection_stage.order
			},
		},
		methods: {
			isActive(session){ return this.activeSessions.some(item=>item.id===session.id) },
			getVariant(session){ return this.isActive(session) ? 'success' : ''; },
		},
	}
</script>
